module.exports = __webpack_public_path__ + "static/media/iconfinder_github_2308116.5b9b92fc.svg";